import { Trash2 } from "lucide-react";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import DeleteModal from "../../common/components/DeleteModal";
import { useState } from "react";
import { Tooltip } from "react-tooltip";

function getFormInputs(organizationName) {
  return [
    {
      type: "text",
      name: "organizationName",
      placeholder: "Organization Name",
      validation: {
        required: "Organization Name is required",
      },
      defaultValue: organizationName,
    },
  ];
}

function OrganizationForm({
  updateOrg,
  isUpdating,
  organizationName,
  deleteOrg,
  isDeleting,
}) {
  const [openDelete, setOpenDelete] = useState(false);

  return (
    <div className="text-gray-700">
      <div className="flex space-x-2">
        <div className=" text-lg">Organization</div>
        <Trash2
          className="text-red-600 hover:text-red-700 cursor-pointer"
          onClick={() => setOpenDelete(true)}
          id="delete-organization"
        />

        <Tooltip anchorSelect="#delete-organization">
          Delete your organization
        </Tooltip>
      </div>

      <div>
        <FormBuilder
          formContainerCls="flex items-center space-x-2"
          formInputs={getFormInputs(organizationName)}
          submitButtonLabel="Update"
          onSubmit={(data) => updateOrg(data)}
          isSubmitting={isUpdating}
        />
      </div>

      <DeleteModal
        title="Are you sure, you are going to delete this organization?"
        open={openDelete}
        setOpen={setOpenDelete}
        onDelete={deleteOrg}
        isDeleting={isDeleting}
      />
    </div>
  );
}

export default OrganizationForm;
